// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"f5812637","145":"3c9be28a","317":"1842cbe6","685":"8aae0a18","787":"7a08595a","980":"03b23e0d"}[chunkId] + ".chunk.js";
};